import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class FuzzbugSprites {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {Phaser.GameObjects.Container} hostSprite
   * @param {Phaser.Textures.Frame} bodyFI
   * @param {Phaser.Textures.Frame} feetFI
   */
  constructor(scene, hostSprite, bodyFI, feetFI) {
    this.scene = scene;

    this.hostSprite = hostSprite;
    this.frameInfoBody = bodyFI;
    this.frameInfoFeet = feetFI;

    this.blinkTimes = { min: 300, max: 1000 };
    this.blinkWaiter = Phaser.Math.Between(this.blinkTimes.min,this.blinkTimes.max) / 1000;

    this.setup();
  }

  setup () {
    const fps = 30;

    this.currentColor = 0xffffff;

    // ARMS
    this.arms = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'FuzzbugAnimation/ArmsDown_0000',
      add: false
    });
    const armsUpFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS,{
      prefix: 'FuzzbugAnimation/ArmsUp_',
      start: 0,
      end: 10,
      zeroPad: 4
    });
    const armsIdleFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'FuzzbugAnimation/ArmsUp_',
      start: 0,
      end: 0,
      zeroPad: 4
    });
    const armsDownFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'FuzzbugAnimation/ArmsDown_',
      start: 0,
      end: 6,
      zeroPad: 4
    });
    const armsSadFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'FuzzbugAnimation/ArmsSad_',
      start: 0,
      end: 12,
      zeroPad: 4
    });
    this.addSpriteAnimation(this.arms, 'armsIdle', armsIdleFrames, fps);
    this.addSpriteAnimation(this.arms, 'armsUp', armsUpFrames, fps);
    this.addSpriteAnimation(this.arms, 'armsDown', armsDownFrames, fps);
    this.addSpriteAnimation(this.arms, 'armsSad', armsSadFrames, fps * 0.25);
    const jumpFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'FuzzbugAnimation/ArmsJump_',
      start: 0,
      end: 20,
      zeroPad: 4
    });
    this.addSpriteAnimation(this.arms, 'armsJump', jumpFrames, fps);
    this.arms.play('armsIdle');

    // LEGS
    this.legs = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'FuzzbugAnimation/LegsHappy_0000',
      add: false
    });
    const legsJumpFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'FuzzbugAnimation/LegsHappy_',
      start: 0,
      end: 16,
      zeroPad: 4
    });
    const legsSadFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'FuzzbugAnimation/LegsSad_',
      start: 0,
      end: 12,
      zeroPad: 4
    });
    this.addSpriteAnimation(this.legs, 'legsJump', legsJumpFrames, fps);
    this.addSpriteAnimation(this.legs, 'legsSad', legsSadFrames, fps);
    this.legs.y = this.frameInfoFeet.height * 0.25;

    // FUZZ BODY
    this.actualFuzz = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'JasonBodyWind/Blow_0000',
      add: false
    });
    this.blowingFuzz = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'JasonBodyWind/Blow_0000',
      add: false
    });

    const windFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'JasonBodyWind/Blow_',
      start: 0,
      end: 9,
      zeroPad: 4
    });
    this.addSpriteAnimation(this.blowingFuzz, 'blow', windFrames, fps, true);

    this.blowingFuzz.active = false;
    this.blowingFuzz.visible = false;

    // EYES
    this.eyes = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'FuzzbugAnimation/EyesOpen_0000',
      add: false,
      y: 10
    });

    /** @type {Phaser.Animations.AnimationFrame[]} */
    const blinkFrames = [
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesShut_0000' },
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesShut_0000' },
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesShut_0000' },
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesShut_0000' },
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesShut_0000' },
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesShut_0000' },
      { key: ABCyaPhaser.Images.DEFAULT_ATLAS, frame: 'FuzzbugAnimation/EyesOpen_0000' }
    ];
    this.addSpriteAnimation(this.eyes, 'blink', blinkFrames, fps);

    // MOUTH
    this.mouth = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'FuzzbugAnimation/MouthSmile_0000',
      add: false,
      y: 10
    });

    this.hostSprite.add(this.legs);
    this.hostSprite.add(this.arms);
    this.hostSprite.add(this.actualFuzz);
    this.hostSprite.add(this.blowingFuzz);
    this.hostSprite.add(this.eyes);
    this.hostSprite.add(this.mouth);

    this.glasses = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'party_hat',
      add: false,
      x: -5,
      y: -63
    });
    this.hostSprite.add(this.glasses);
    this.glasses.active = false;
    this.glasses.visible = false;

    this.hat = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'party_hat',
      add: false,
      x: -5,
      y: -63
    });
    const spinHatFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'hat_animation/',
      start: 0,
      end: 8,
      zeroPad: 4
    });
    this.addSpriteAnimation(this.hat, 'spin', spinHatFrames, fps, true);
    this.hostSprite.add(this.hat);
    this.hat.active = false;
    this.hat.visible = false;

    this.paintSplash = this.scene.make.sprite({
      key: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frame: 'filler_spurt_0001',
      add: false,
      y: 43
    });
    const splatFrames = this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'filler_spurt_',
      start: 1,
      end: 8,
      zeroPad: 4
    });
    this.addSpriteAnimation(this.paintSplash, 'splatter', splatFrames, fps * 0.5);
    this.hostSprite.add(this.paintSplash);
    this.paintSplash.on(Phaser.Animations.Events.ANIMATION_COMPLETE, this.splashComplete, this);
    this.paintSplash.active = false;
    this.paintSplash.visible = false;

    this.armsUp = false;
  }

  /**
   * 
   * @param {Phaser.GameObjects.Sprite} sprite 
   * @param {string} animationName 
   * @param {Phaser.Animations.AnimationFrame[]} frames 
   * @param {number} fps 
   * @param {boolean} loop 
   */
  addSpriteAnimation (sprite, animationName, frames, fps = 30, loop = false) {
    sprite.anims.create({
      key: animationName,
      frames,
      frameRate: fps,
      repeat: loop ? -1 : 0,
    });
  }

  makeSad() {
    this.arms.play('armsSad');
    this.legs.play('legsSad');
    this.mouth.setFrame('FuzzbugAnimation/MouthFrown_0000');
  }

  celebrate() {
    this.arms.play('armsJump');
    this.legs.play('legsJump');
    this.mouth.setFrame('FuzzbugAnimation/MouthOpen_0000');
  }

  backToHappy() {
    this.mouth.setFrame('FuzzbugAnimation/MouthSmile_0000');
  }

  startBlow() {
    if (this.blowingFuzz.active) return;
    this.actualFuzz.active = false;
    this.actualFuzz.visible = false;

    this.blowingFuzz.tint = this.currentColor;
    this.blowingFuzz.active = true;
    this.blowingFuzz.visible = true;
    this.blowingFuzz.play('blow');
  }

  stopBlow() {
    if (!this.blowingFuzz.active) return;
    this.blowingFuzz.active = false;
    this.blowingFuzz.visible = false;
    this.actualFuzz.active = true;
    this.actualFuzz.visible = true;
  }

  showHat(data) {
    if (data.texture === 'pinwheel_hat') {
      this.hat.play('spin');
    }
    else {
      this.hat.stop();
      this.hat.setFrame(data.texture);
    }

    this.hat.x = data.offset.x;
    this.hat.y = data.offset.y;
    this.hat.active = true;
    this.hat.visible = true;
  }

  showGlasses(data) {
    this.glasses.setFrame(data.texture);
    this.glasses.x = data.offset.x;
    this.glasses.y = data.offset.y;
    this.glasses.active = true;
    this.glasses.visible = true;
  }

  splash(color) {
    this.currentColor = color;

    this.blowingFuzz.tint = color;
    this.paintSplash.tint = color;
    this.paintSplash.active = true;
    this.paintSplash.visible = true;
    this.paintSplash.play('splatter');
  }

  splashComplete() {
    this.paintSplash.active = false;
    this.paintSplash.visible = false;
  }

  changeColor(data) {
    this.actualFuzz.setFrame(`bodycolor_${data.value}`);
  }

  doJump(freeJumping = true) {
    this.armsUp = true;
    if (freeJumping) {
      this.arms.play('armsUp');
    }
    else {
      this.arms.play('armsJump');
    }
    this.legs.play('legsJump');
  }

  startDown() {
    if (this.armsUp) {
      this.arms.play('armsDown');
      this.armsUp = false;
    }
  }

  update(dt) {
    this.blinkWaiter -= dt;
    if (this.blinkWaiter <= 0) {
      this.eyes.play('blink');
      this.blinkWaiter = Phaser.Math.Between(this.blinkTimes.min,this.blinkTimes.max) / 100;
    }
  }
}